import { AbstractControl, ValidatorFn } from '@angular/forms';

export function urlValidator(): ValidatorFn {
	const regex = new RegExp('(https?://)([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
	return (control: AbstractControl) => {
		if (!control.value) return null;
		const validUrl = regex.test(control.value);
		return validUrl ? null : { invalidUrl: true };
	};
}
